import { cn } from '@/lib/utils';
import Spinner from '.';

interface LoadingOverlayProps {
  showSpinner?: boolean;
  overlayClassName?: string;
}

const LoadingOverlay = ({ showSpinner = false, overlayClassName }: LoadingOverlayProps) => {
  return (
    <div className='absolute top-0 left-0 z-50 flex items-center justify-center w-full h-full'>
      {/* Background overlay */}
      <div
        className={cn(
          'absolute top-0 left-0 w-full h-full bg-gray-300 opacity-75 backdrop-blur-sm',
          overlayClassName
        )}
      ></div>
      {/* Spinner content */}
      {showSpinner ? (
        <Spinner />
      ) : (
        <div className='relative flex gap-2'>
          <div className='w-5 h-5 rounded-full animate-pulse bg-blue-600'></div>
          <div className='w-5 h-5 rounded-full animate-pulse bg-blue-600'></div>
          <div className='w-5 h-5 rounded-full animate-pulse bg-blue-600'></div>
        </div>
      )}
    </div>
  );
};

export default LoadingOverlay;
